import React from "react";
import { Star, Quote } from "lucide-react";

const Testimonials = () => {
  const testimonials = [
    {
      quote: "Zeelium transformed our security operations completely. We went from drowning in alerts to having clear, actionable intelligence. Our mean time to remediation dropped from 3 weeks to 2 days.",
      author: "Sarah Chen",
      role: "CISO",
      company: "TechForward Inc.",
      rating: 5
    },
    {
      quote: "The ROI analytics finally gave us the visibility we needed to prove security program value to the board. We identified $2M in tool redundancies and optimized our entire security stack.",
      author: "Michael Rodriguez", 
      role: "VP of Security",
      company: "GlobalBank Corp.",
      rating: 5
    },
    {
      quote: "False positive reduction alone saved our team 20 hours per week. Now we focus on real threats instead of chasing ghosts. The autonomous remediation is game-changing.",
      author: "Jennifer Park",
      role: "Security Engineer",
      company: "CloudScale Systems",
      rating: 5
    },
    {
      quote: "Accountability was our biggest challenge before Zeelium. Now every vulnerability has an owner, timeline, and clear escalation path. Nothing falls through the cracks anymore.",
      author: "David Thompson",
      role: "Security Manager", 
      company: "FinTech Innovations",
      rating: 5
    }
  ];

  return null;
  // return (
  //   <section className="py-20 bg-gray-50">
  //     <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
  //       {/* Section Header */}
  //       <div className="text-center mb-16">
  //         <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
  //           Trusted by Security
  //           <span className="text-blue-600 block">Leaders Worldwide</span>
  //         </h2>
  //         <p className="text-xl text-gray-600 max-w-3xl mx-auto">
  //           See how leading organizations are achieving unprecedented security efficiency 
  //           and protection with Zeelium's AI-powered platform.
  //         </p>
  //       </div>
  //
  //       {/* Testimonials Grid */}
  //       <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
  //         {testimonials.map((testimonial, index) => (
  //           <div 
  //             key={index}
  //             className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-lg transition-all duration-300"
  //           >
  //             {/* Quote Icon */}
  //             <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center text-blue-600 mb-6">
  //               <Quote className="w-6 h-6" />
  //             </div>
  //
  //             {/* Rating */}
  //             <div className="flex items-center mb-6">
  //               {[...Array(testimonial.rating)].map((_, i) => (
  //                 <Star key={i} className="w-5 h-5 text-yellow-400 fill-current" />
  //               ))}
  //             </div>
  //
  //             {/* Quote */}
  //             <blockquote className="text-lg text-gray-700 leading-relaxed mb-8">
  //               "{testimonial.quote}"
  //             </blockquote>
  //
  //             {/* Author */}
  //             <div className="flex items-center">
  //               <div className="w-12 h-12 bg-gradient-to-br from-blue-100 to-indigo-100 rounded-full flex items-center justify-center text-blue-600 font-semibold mr-4">
  //                 {testimonial.author.split(' ').map(n => n[0]).join('')}
  //               </div>
  //               <div>
  //                 <div className="font-semibold text-gray-900">
  //                   {testimonial.author}
  //                 </div>
  //                 <div className="text-gray-600">
  //                   {testimonial.role}, {testimonial.company}
  //                 </div>
  //               </div>
  //             </div>
  //           </div>
  //         ))}
  //       </div>
  //
  //       {/* Trust Indicators */}
  //       <div className="bg-white rounded-2xl p-8 shadow-sm">
  //         <div className="text-center mb-8">
  //           <h3 className="text-2xl font-bold text-gray-900 mb-4">
  //             Join 500+ Organizations Already Using Zeelium
  //           </h3>
  //           <p className="text-gray-600">
  //             From startups to Fortune 500 companies, security teams trust Zeelium
  //           </p>
  //         </div>
  //         
  //         <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
  //           <div className="text-center">
  //             <div className="text-3xl font-bold text-gray-900 mb-2">500+</div>
  //             <div className="text-gray-600">Organizations Protected</div>
  //           </div>
  //           <div className="text-center">
  //             <div className="text-3xl font-bold text-gray-900 mb-2">10M+</div>
  //             <div className="text-gray-600">Vulnerabilities Managed</div>
  //           </div>
  //           <div className="text-center">
  //             <div className="text-3xl font-bold text-gray-900 mb-2">99.9%</div>
  //             <div className="text-gray-600">Platform Uptime</div>
  //           </div>
  //           <div className="text-center">
  //             <div className="text-3xl font-bold text-gray-900 mb-2">24/7</div>
  //             <div className="text-gray-600">Expert Support</div>
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   </section>
  // );
};

export default Testimonials;
